module.exports = __webpack_public_path__ + "static/media/play-board-4.95935f46.png";